import { render, staticRenderFns } from "./InstallationsSideviewGeneralTab.vue?vue&type=template&id=28faac96&scoped=true&class=fill-height"
import script from "./InstallationsSideviewGeneralTab.vue?vue&type=script&lang=ts"
export * from "./InstallationsSideviewGeneralTab.vue?vue&type=script&lang=ts"
import style0 from "./InstallationsSideviewGeneralTab.vue?vue&type=style&index=0&id=28faac96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28faac96",
  null
  
)

export default component.exports